module.exports = __webpack_public_path__ + "static/media/covid.f19cc9d4.png";